export enum AppDragTypes {
    MsoTableRow
}